'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.chatHeadingRespondersList = chatHeadingRespondersList;

var _immutable = require('immutable');

var _hasUserAndTeamResponders = require('conversations-schema/chat-heading-config/operators/hasUserAndTeamResponders');

var MAX_POTENTIAL_RESPONDERS = 3;

function chatHeadingRespondersList(_ref) {
  var _ref$assignedResponde = _ref.assignedResponder,
      assignedResponder = _ref$assignedResponde === undefined ? null : _ref$assignedResponde,
      chatHeadingConfig = _ref.chatHeadingConfig,
      responders = _ref.responders,
      _ref$sendFromResponde = _ref.sendFromResponders,
      sendFromResponders = _ref$sendFromResponde === undefined ? responders : _ref$sendFromResponde;

  var respondersToPass = assignedResponder ? (0, _immutable.List)([assignedResponder]) : sendFromResponders;

  var chatHeadingResponders = !respondersToPass.size && ((0, _hasUserAndTeamResponders.hasUserAndTeamResponders)(chatHeadingConfig) || !chatHeadingConfig) ? responders : respondersToPass;

  return chatHeadingResponders.take(MAX_POTENTIAL_RESPONDERS);
}